export interface SatuEventConfig {
  enabled: boolean
  debugEnabled: boolean
  url?: string
  username?: string
  password?: string
  mengajar_username?: string
  mengajar_password?: string
  sessionStorageKey: string
}

export const loadConfig = (
  env?: Record<string, string | undefined>
): SatuEventConfig => {
  // In browser/client-side, use direct process.env access for webpack replacement
  // In tests or when env is provided, use the passed env object
  const envSource =
    env ||
    (typeof process !== 'undefined' && typeof window !== 'undefined'
      ? {
          NEXT_PUBLIC_SATU_EVENT_ENABLED:
            process.env.NEXT_PUBLIC_SATU_EVENT_ENABLED,
          NEXT_PUBLIC_SATU_EVENT_DEBUG:
            process.env.NEXT_PUBLIC_SATU_EVENT_DEBUG,
          NEXT_PUBLIC_SATU_EVENT_API_URL:
            process.env.NEXT_PUBLIC_SATU_EVENT_API_URL,
          NEXT_PUBLIC_SATU_EVENT_USERNAME:
            process.env.NEXT_PUBLIC_SATU_EVENT_USERNAME,
          NEXT_PUBLIC_SATU_EVENT_PASSWORD:
            process.env.NEXT_PUBLIC_SATU_EVENT_PASSWORD,
          NEXT_PUBLIC_SATU_EVENT_MENGAJAR_USERNAME:
            process.env.NEXT_PUBLIC_SATU_EVENT_MENGAJAR_USERNAME,
          NEXT_PUBLIC_SATU_EVENT_MENGAJAR_PASSWORD:
            process.env.NEXT_PUBLIC_SATU_EVENT_MENGAJAR_PASSWORD,
          NEXT_PUBLIC_SATU_EVENT_SESSION_STORAGE_KEY:
            process.env.NEXT_PUBLIC_SATU_EVENT_SESSION_STORAGE_KEY,
        }
      : process.env)

  return {
    enabled: envSource.NEXT_PUBLIC_SATU_EVENT_ENABLED === 'true',
    debugEnabled: envSource.NEXT_PUBLIC_SATU_EVENT_DEBUG === 'true',
    url: envSource.NEXT_PUBLIC_SATU_EVENT_API_URL,
    username: envSource.NEXT_PUBLIC_SATU_EVENT_USERNAME,
    password: envSource.NEXT_PUBLIC_SATU_EVENT_PASSWORD,
    mengajar_username: envSource.NEXT_PUBLIC_SATU_EVENT_MENGAJAR_USERNAME,
    mengajar_password: envSource.NEXT_PUBLIC_SATU_EVENT_MENGAJAR_PASSWORD,
    sessionStorageKey:
      envSource.NEXT_PUBLIC_SATU_EVENT_SESSION_STORAGE_KEY || 'app-login',
  }
}
